import styled from 'styled-components';

export const CardCertification = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 5px;
  padding: 0 10px;
  min-height: 80px;
  width: 100%;

  @media (min-width: 1024px) {
    &:hover p {
      display: none;
    }

    &:hover > div {
      display: block !important;
    }
  }
`;

export const Image = styled.img`
  object-fit: contain;
  max-width: 50px !important;
  max-height: 50px !important;
  width: auto;
  height: auto;
  margin-right: 5%;

  @media (max-width: 768px) {
    max-width: 50px;
  }
`;

export const SeeDetails = styled.div`
  @media (min-width: 1024px) {
    display: none;
  }

  strong {
    cursor: pointer;
    font-size: 12px;
    color: #828ea0;
    margin: 0;
    font-weight: 500;
  }
`;

export const CardCertificationInformation = styled.div`
  display: none;
  height: auto;

  p {
    margin: 2px;
  }

  @media (min-width: 1024px) {
    display: block;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
  }
`;

export const CardCertificationName = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #010101;
`;

export const CertificationStatus = styled.span`
  text-align: top;
  border: 1px solid #009688;
  border-radius: 21px;
  color: #009688;
  display: inline-block;
  padding: 2px 11px 0px 11px;
  font-weight: 600;
  font-size: 14px;
  margin-left: 5px;
`;

export const CertificationExpires = styled.p`
  font-size: 12px;
  color: #828ea0;
`;

export const CertificationDate = styled.p`
  font-size: 12px;
  color: #010101;
  padding-top: 3px;
`;
